function updateSubscriptionPrices(newPriceCents) {
  const subscriptionApp = document.querySelector('.shopify_subscriptions_app_container, .shopify_subscriptions_app_block');
  if (!subscriptionApp) return;

  const newPrice = (newPriceCents / 100).toFixed(2).replace('.', ',') + '€';

  const oneTimePriceEl = subscriptionApp.querySelector('.shopify_subscriptions_purchase_option_wrapper .shopify_subscriptions_in_widget_price');
  if (oneTimePriceEl) oneTimePriceEl.textContent = newPrice;

  const selectedSubscriptionRadio = subscriptionApp.querySelector('input[data-radio-type="selling_plan"]:checked');
  
  let discountPercent = 0;
  let selectedSubscriptionLabel;

  if (selectedSubscriptionRadio) {

    selectedSubscriptionLabel = selectedSubscriptionRadio.closest('label');
  } else {
    selectedSubscriptionLabel = subscriptionApp.querySelector('.shopify_subscriptions_purchase_option_wrapper + .shopify_subscriptions_app_block_label label');
  }

  if (selectedSubscriptionLabel) {
    const match = selectedSubscriptionLabel.textContent.match(/(\d+)\s*%/); 
    if (match) discountPercent = parseInt(match[1], 10);
  }

  const discountedPriceCents = Math.round(newPriceCents * (1 - discountPercent / 100));
  const discountedPrice = (discountedPriceCents / 100).toFixed(2).replace('.', ',') + '€';

  const allocationPriceEl = subscriptionApp.querySelector('.allocation_price');
  if (allocationPriceEl) allocationPriceEl.textContent = discountedPrice;

  const oneTimeRadio = subscriptionApp.querySelector('.shopify_subscriptions_app_block_one_time_purchase_option');
  if (oneTimeRadio) oneTimeRadio.setAttribute('data-variant-price', newPrice);

  const subscriptionRadios = subscriptionApp.querySelectorAll('input[data-radio-type="selling_plan"]');
  subscriptionRadios.forEach(radio => {
    let specificDiscount = 0;
    const radioLabel = radio.closest('label');
    if (radioLabel) {
      const match = radioLabel.textContent.match(/(\d+)\s*%/);
      if (match) specificDiscount = parseInt(match[1], 10);
    }

    const specificDiscountedPriceCents = Math.round(newPriceCents * (1 - specificDiscount / 100));
    const specificDiscountedPrice = (specificDiscountedPriceCents / 100).toFixed(2).replace('.', ',') + '€';

    radio.setAttribute('data-variant-price', specificDiscountedPrice);
    radio.setAttribute('data-variant-compare-at-price', newPrice);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const bundleBlocks = Array.from(document.querySelectorAll('.bundle-item-block'));
  if (!bundleBlocks.length) return;

  const mainSelect = document.querySelector('select[name="id"], select.select__select');
  const variantInput = document.getElementById('bundle-selected-variant');
  const quantityInput = document.getElementById('bundle-selected-quantity');
  const addToCartButton = document.querySelector('.product-form__submit');
  const priceBundleDiv = document.getElementById('price-bundle');

  function formatPriceFromEuros(euros) {
    return euros.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }).replace(/\s?€/g, '€');
  }

  function getSelectedVariantInfo(select) {
    if (!select) return { id: null, priceCents: 0 };
    const opt = select.selectedOptions[0];
    if (!opt) return { id: null, priceCents: 0 };
    return { id: opt.value, priceCents: parseInt(opt.dataset.price || 0) };
  }

  function updateMainSelectVariant(variantId) {
    if (!mainSelect || !variantId) return;
    mainSelect.value = variantId;
    ['change', 'input'].forEach(eventName => {
      let evt;
      try { evt = new Event(eventName, { bubbles: true }); } 
      catch(e) { evt = document.createEvent('HTMLEvents'); evt.initEvent(eventName, true, false); }
      mainSelect.dispatchEvent(evt);
    });
    if (typeof jQuery !== 'undefined') jQuery(mainSelect).trigger('change');
  }

  function updateAddToCartPrice(finalPriceCents, originalPriceCents, discount) {
    if (addToCartButton) {
      const span = addToCartButton.querySelector('span');
      if (span) {
        const original = span.dataset.originalText || span.textContent.trim();
        if (!span.dataset.originalText) span.dataset.originalText = original;

        const finalPriceHtml = formatPriceFromEuros(finalPriceCents / 100);
        let html = `${original} <span class="bundle-price-final">- ${finalPriceHtml}</span>`;

        if (discount > 0) {
          const originalPriceHtml = formatPriceFromEuros(originalPriceCents / 100);
          html += ` <span class="bundle-price-details">- ${originalPriceHtml}</span>`;
        }
        span.innerHTML = html;
      }
    }
  }

  function updateBundleBlock(block) {
    const label = block.querySelector('.bundle-option-label');
    const radio = label.querySelector('input[type="radio"]');
    const select = block.querySelector('.bundle-inner-select');

    const quantity = parseInt(label.dataset.quantity || 1);
    const discount = parseFloat(label.dataset.discount || 0);
    const { id: variantId, priceCents } = getSelectedVariantInfo(select);

    // BEUG ROUNDING SHOPIFY DISCOUNT (?)
    const totalOriginalCents = priceCents * quantity;
    const discountedUnit = priceCents * (1 - discount / 100);
    const totalFinalCents = Math.round(discountedUnit * quantity);

    const priceWrapper = block.querySelector('.bundle-price-wrapper');
    if (priceWrapper) {
      const finalPriceEl = priceWrapper.querySelector('.bundle-price-final');
      const detailsEl = priceWrapper.querySelector('.bundle-price-details');
      if (finalPriceEl) finalPriceEl.textContent = formatPriceFromEuros(totalFinalCents / 100);
      if (detailsEl) {
        if (discount > 0) {
          detailsEl.style.display = 'inline';
          detailsEl.textContent = formatPriceFromEuros(totalOriginalCents / 100);
        } else {
          detailsEl.style.display = 'none';
        }
      }
    }

    if (priceBundleDiv) {
      priceBundleDiv.innerHTML = `
        <span class="bundle-price-final">${formatPriceFromEuros(totalFinalCents / 100)}</span>
        ${discount > 0 ? `<span class="bundle-price-details">${formatPriceFromEuros(totalOriginalCents / 100)}</span>` : ''}
      `;
    }

    if (radio.checked) {
      bundleBlocks.forEach(b => b.classList.remove('selected'));
      block.classList.add('selected');

      if (variantInput) variantInput.value = variantId;
      if (quantityInput) quantityInput.value = quantity;
      updateMainSelectVariant(variantId);

      const subscriptionApp = document.querySelector('.shopify_subscriptions_app_container, .shopify_subscriptions_app_block');
      const oneTimeRadio = document.querySelector('.shopify_subscriptions_app_block_one_time_purchase_option');
      const subscriptionRadios = document.querySelectorAll('input[data-radio-type="selling_plan"]');

      if (subscriptionApp) {
        if (quantity === 1) {
          subscriptionApp.style.display = 'block';
        } else {
          subscriptionApp.style.display = 'none';

          // Force "Achat ponctuel"
          if (oneTimeRadio) {
            oneTimeRadio.checked = true;
            subscriptionRadios.forEach(r => r.checked = false);

            let evt;
            try { evt = new Event('change', { bubbles: true }); }
            catch (e) { evt = document.createEvent('HTMLEvents'); evt.initEvent('change', true, false); }

            oneTimeRadio.dispatchEvent(evt);
          }
        }
      }

      updateSubscriptionPrices(priceCents);

      const subscriptionSelected = document.querySelector('input[data-radio-type="selling_plan"]:checked');
      if (subscriptionSelected) {
        const subPriceText = subscriptionSelected.getAttribute('data-variant-price'); // ex: "18,91€"

        if (addToCartButton) {
          const span = addToCartButton.querySelector('span');
          if (span) {
            const original = span.dataset.originalText || span.textContent.trim();
            if (!span.dataset.originalText) span.dataset.originalText = original;

            span.innerHTML = `${original} <span class="bundle-price-final">- ${subPriceText}</span>`;
          }
        }

        return; 
      }

      updateAddToCartPrice(totalFinalCents, totalOriginalCents, discount);

    } else {
      block.classList.remove('selected');
    }
  }

  function protectSelectFromLabel(select) {
    if (!select) return;
    select.addEventListener('click', e => e.stopPropagation(), { passive: true });
    select.addEventListener('touchstart', e => e.stopPropagation(), { passive: true });
  }

  function handleSubscriptionOptionChange() {
    const selectedBundleBlock = bundleBlocks.find(b =>
        b.querySelector('.bundle-option-label input[type="radio"]').checked
    );

    if (!selectedBundleBlock) return;
    
    const label = selectedBundleBlock.querySelector('.bundle-option-label');
    const select = selectedBundleBlock.querySelector('.bundle-inner-select');
    const quantity = parseInt(label.dataset.quantity || 1);
    const discount = parseFloat(label.dataset.discount || 0);
    const { priceCents } = getSelectedVariantInfo(select);

    const totalOriginalCents = priceCents * quantity;
    const discountedUnit = priceCents * (1 - discount / 100);
    const totalFinalCents = Math.round(discountedUnit * quantity);


    const subscriptionSelected = document.querySelector('input[data-radio-type="selling_plan"]:checked');
    if (subscriptionSelected) {
        
        const subPriceText = subscriptionSelected.getAttribute('data-variant-price'); 
        if (addToCartButton) {
            const span = addToCartButton.querySelector('span');
            if (span) {
                const original = span.dataset.originalText || span.textContent.trim();
                if (!span.dataset.originalText) span.dataset.originalText = original;
                span.innerHTML = `${original} <span class="bundle-price-final">- ${subPriceText}</span>`;
            }
        }
    } else {
        updateAddToCartPrice(totalFinalCents, totalOriginalCents, discount);
    }
  }

  bundleBlocks.forEach(block => {
    const label = block.querySelector('.bundle-option-label');
    const radio = label.querySelector('input[type="radio"]');
    const select = block.querySelector('.bundle-inner-select');

    protectSelectFromLabel(select);

    if (select) {
      select.addEventListener('change', () => {
        if (radio && !radio.checked) radio.checked = true;
        updateBundleBlock(block);
      });
    }

    if (radio) {
      radio.addEventListener('change', () => {
        if (radio.checked) updateBundleBlock(block);
      });
    }

    updateBundleBlock(block);
  });
  
  const subscriptionApp = document.querySelector('.shopify_subscriptions_app_container, .shopify_subscriptions_app_block');
  if (subscriptionApp) {
    const purchaseOptionRadios = document.querySelectorAll('.shopify_subscriptions_app_block_one_time_purchase_option, input[data-radio-type="selling_plan"]');
    purchaseOptionRadios.forEach(radio => {
        radio.addEventListener('change', handleSubscriptionOptionChange);
    });
  }

const selectedBlock = bundleBlocks.find(b =>
  b.querySelector('.bundle-option-label input[type="radio"]').checked
) || bundleBlocks[0]; 

if (selectedBlock) updateBundleBlock(selectedBlock);
  
  handleSubscriptionOptionChange();
});



